import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import CustomModalWrapper from 'components/CustomModalWrapper/CustomModalWrapper';
import TableWithStickyHeader from 'components/TableWithStickyHeader';
import moment from 'moment';
import React from 'react';
import Select from 'react-select';

// reactstrap components
import {
  MagicSpinner,
  // TraceSpinner
} from 'react-spinners-kit';
import {
  Card,
  CardHeader,
  CardBody,
  // CardTitle,
  Table,
  Row,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

import { SCANS_FORMAT_TYPES } from '../../components/Styles/Filter';
import { verifyAccessToken } from '../../lib/auth';
import axios from '../../lib/axiosInstance';
import '@y0c/react-datepicker/assets/styles/calendar.scss';

import NoRecordFound from '../../components/NoRecordFound/NoRecordFound';

import './list.css';

// import calendar style
const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};

class ScanList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      currentReport: {},
      // currentData: {},
      tagData: [],
      searchValue: '',
      currentTag: {},
      selectedTags: [],
      company_search_data: '',
      openModal: false,
      loader: true,
      currentPage: 0,
      ordering: '-updated_at',
      currentTab: 'ep_scans',
      scan_format_type: { value: '', label: 'All' },
    };

    this.handleTabChange.bind(this);
  }
  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchScans();
    }, 60);
  }

  handleTabChange(tab) {
    this.setState({ currentTab: tab, count: 0 });
    let self = this;
    setTimeout(function () {
      self.fetchScans();
    }, 60);
  }

  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  componentDidMount() {
    let search = window.location.search.split('search=');
    if (search.length > 1) {
      search = window.location.search.split('search=')[1].split('&')[0];
      this.setState({ company_search_data: search });
    }
    this.fetchScans();
    localStorage.setItem('last_path', window.location.pathname);
  }
  componentDidUpdate(prevProps, prevState) {
    // Check if the specific prop has been updated
    if (this.props.currentCompanyId !== prevProps.currentCompanyId) {
      this.updatePage();
    }
  }

  updatePage() {
    this.fetchScans();
  }

  async fetchScans(currentUrl, currentPage, company_id) {
    this.setState({ loader: true });
    if (company_id === undefined) {
      company_id = this.props.currentCompanyId;
    }
    await verifyAccessToken();
    let url = '/scans/?search=' + this.state.company_search_data,
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (currentUrl) {
      url = currentUrl;
    }
    url += '&ordering=' + this.state.ordering;
    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }
    url += '&company=' + company_id;

    // add web app or endpoint scans filter
    url +=
      '&scan_ref=' + (this.state.currentTab === 'ep_scans' ? 'scan' : 'was');
    if (this.state.scan_format_type.value !== '') {
      url += '&scan_type=' + this.state.scan_format_type.value;
    }

    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? '/scans/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/scans/?' + res.data.previous.split('?')[1]
                : null,
            });
            document.getElementsByClassName('main-panel')[0].scrollTop = 0;
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }

  async fetchScanDetail(id) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/scans/' + id + '/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loader: false });
        //console.log('Fetched Data',res.data)
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            // let currentData = res.data
            this.setState({
              currentReport: res.data,
              loader: false,
              modal: true,
            });
          }
        } else {
          console.warn('Unhandled status: ' + res.status);
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        console.error(err);
      });
  }
  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() =>
              this.fetchScans(this.state.nextUrl, this.state.currentPage + 1)
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() =>
              this.fetchScans(
                this.state.previousUrl,
                this.state.currentPage - 1,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / 25.0),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      let url =
        '/scans/?search=' +
        this.state.company_search_data +
        '&limit=25&offset=' +
        parseInt(25 * index);
      pages.push(
        <PaginationItem
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchScans(url, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // for (let index = 0; index < rightPages; index++) {
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        let url =
          '/scans/?search=' +
          this.state.company_search_data +
          '&limit=25&offset=' +
          parseInt(25 * pageIndex);
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink onClick={() => this.fetchScans(url, pageIndex)}>
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    if (rightPages >= 1) {
      let url =
        '/scans/?search=' +
        this.state.company_search_data +
        '&limit=25&offset=' +
        parseInt(25 * (pageCount - 1));
      pages.push(
        <PaginationItem
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchScans(url, pageCount - 1)}>
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / 25.0);
    if (pageCount > 1)
      return (
        <>
          <Pagination aria-label="Page navigation example">
            {this.renderPreviousUrl()}
            {this.renderPages()}
            {this.renderNextUrl()}
          </Pagination>
        </>
      );
  }
  renderButton(data) {
    // if(data.report_status === 'COMPLETE'){
    return (
      <>
        <Button
          color="primary"
          outline
          size="sm"
          title={'Show details'}
          onClick={() => this.fetchScanDetail.bind(this)(data.id)}
        >
          <i className="fa fa-eye"></i>
        </Button>
      </>
    );
  }
  renderReportList() {
    let reports = this.state.reports;
    // data = []
    return (
      <>
        {reports.map((data, idx) => {
          return (
            // <th>ID</th>
            // <th>Name</th>
            // <th>Active Reports</th>
            // <th>Total Reports</th>
            // <th>Creation Date</th>
            // <th>Owner</th>
            // <th>Members</th>
            // <th className="text-right">
            // </th>
            <tr>
              <td>{data['id']}</td>
              {/* <td>{data['company']}</td> */}
              <td>{data['title']}</td>
              {/* <td>{data['ref']}</td> */}
              <td>{data['scan_type']}</td>
              <td>{data['duration'] || 'N/A'}</td>
              {this.state.currentTab === 'ep_scans' && (
                <td>{data['processing_priority']}</td>
              )}
              {/* <td>{data['processed']}</td> */}
              <td>{data['status']}</td>
              <td>{moment(data['launch_datetime']).format('lll')}</td>
              <td>{moment(data['updated_at']).format('lll')}</td>
              <td className="text-right">
                {this.renderButton.bind(this)(data)}
              </td>
            </tr>
          );
        })}
      </>
    );
  }
  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        <Collapse in={this.state.openModal === true}>
          <Alert
            severity={this.state.is_success === true ? 'success' : 'error'}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({ openModal: false });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle>{this.state.modalTitle}</AlertTitle>
            {this.state.modalDetail}
          </Alert>
        </Collapse>
      </>
    );
  }

  render() {
    // let tagData = this.state.tagData;
    let { currentTab, scan_format_type } = this.state;

    let ep_tab_class =
      currentTab === 'ep_scans' ? 'nav-link active' : 'nav-link';
    let was_tab_class =
      currentTab === 'was_scans' ? 'nav-link active' : 'nav-link';

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6" sm="12" className="remove-right-padding">
                      <ul className="nav nav-tabs">
                        <li className="nav-item" role="presentation">
                          <a
                            className={ep_tab_class}
                            href="#"
                            onClick={() => this.handleTabChange('ep_scans')}
                          >
                            <h4>
                              Endpoint Scans
                              {currentTab === 'ep_scans' && (
                                <label className="label btn">
                                  {this.state.count}
                                </label>
                              )}
                            </h4>
                          </a>
                        </li>
                        <li className="nav-item" role="presentation">
                          <a
                            className={was_tab_class}
                            href="#"
                            onClick={() => this.handleTabChange('was_scans')}
                          >
                            <h4>
                              Web App Scans
                              {currentTab === 'was_scans' && (
                                <label className="label btn">
                                  {this.state.count}
                                </label>
                              )}
                            </h4>
                          </a>
                        </li>
                      </ul>
                    </Col>
                    <Col
                      md="6"
                      sm="12"
                      className="text-right add-border-bottom"
                    >
                      <Row className="justify-content-end">
                        <Col
                          md="3"
                          sm="12"
                          className="text-right"
                          style={{
                            marginTop: '10px',
                            paddingLeft: 'inherit',
                            paddingRight: 'inherit',
                          }}
                        >
                          <Select
                            className="custom-360-dropdown"
                            value={scan_format_type}
                            onChange={(e) => {
                              // e.preventDefault()
                              this.setState({
                                scan_format_type: e,
                              });
                              let self = this;
                              setTimeout(function () {
                                self.fetchScans();
                              }, 100);
                            }}
                            styles={colourStyles}
                            options={SCANS_FORMAT_TYPES}
                          />
                        </Col>
                        <Col md="6" sm="12" className="text-right">
                          <Input
                            type="text"
                            list="data"
                            style={{ marginTop: '9px' }}
                            value={this.state.company_search_data}
                            placeholder="Search Scan"
                            onChange={(e) => {
                              this.setState({
                                company_search_data: e.target.value,
                              });
                              this.fetchScans();
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.count == 0 && <NoRecordFound />}
                {this.state.count != 0 && (
                  <CardBody>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          <th
                            onClick={() => {
                              this.orderBy('id');
                            }}
                          >
                            ID
                            <i
                              className={
                                this.state.ordering === 'id'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-id'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          {/* <th  onClick={() => {
                                                    this.orderBy('company')
                                                }}>company
                                                <i className={this.state.ordering === 'company' ? 'fa fa-sort-amount-down' : (this.state.ordering === '-company' ? 'fa fa-sort-amount-up' : 'fa fa-sort')} ></i>
                                                </th> */}
                          <th
                            onClick={() => {
                              this.orderBy('title');
                            }}
                          >
                            Title
                            <i
                              className={
                                this.state.ordering === 'title'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-title'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          {/*
                                                <th  onClick={() => {
                                                    this.orderBy('ref')
                                                }}>ref
                                                <i className={this.state.ordering === 'ref' ? 'fa fa-sort-amount-down' : (this.state.ordering === '-ref' ? 'fa fa-sort-amount-up' : 'fa fa-sort')} ></i>
                                                </th> */}
                          <th
                            onClick={() => {
                              this.orderBy('scan_type');
                            }}
                          >
                            Scan type
                            <i
                              className={
                                this.state.ordering === 'scan_type'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-scan_type'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>

                          <th
                            onClick={() => {
                              this.orderBy('duration');
                            }}
                          >
                            Duration
                            <i
                              className={
                                this.state.ordering === 'duration'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-duration'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          {currentTab === 'ep_scans' && (
                            <th
                              onClick={() => {
                                this.orderBy('processing_priority');
                              }}
                            >
                              Processing priority
                              <i
                                className={
                                  this.state.ordering === 'processing_priority'
                                    ? 'fa fa-sort-amount-down'
                                    : this.state.ordering ===
                                      '-processing_priority'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                                }
                              ></i>
                            </th>
                          )}
                          <th
                            onClick={() => {
                              this.orderBy('status');
                            }}
                          >
                            Status
                            <i
                              className={
                                this.state.ordering === 'status'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-status'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('launch_datetime');
                            }}
                          >
                            Launch datetime
                            <i
                              className={
                                this.state.ordering === 'launch_datetime'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-launch_datetime'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('updated_at');
                            }}
                          >
                            Last Updated
                            <i
                              className={
                                this.state.ordering === 'updated_at'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-updated_at'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th className="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </TableWithStickyHeader>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle.bind(this)}
          size="lg"
        >
          <ModalHeader toggle={this.toggle.bind(this)}>Scan Detail</ModalHeader>
          <ModalBody>
            <CustomModalWrapper id="scan-detail">
              <Table className="tablesorter table-striped" responsive>
                <tbody>
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>ID</td>
                    <td>{this.state.currentReport.id}</td>
                  </tr>

                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>title</td>
                    <td>{this.state.currentReport.title}</td>
                  </tr>

                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>ips</td>
                      <td>{this.state.currentReport.ips}</td>
                    </tr>
                  )}
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>
                        excluded ips
                      </td>
                      <td>{this.state.currentReport.excluded_ips}</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>duration</td>
                    <td>{this.state.currentReport.duration || 'N/A'}</td>
                  </tr>
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>
                        active hosts
                      </td>
                      <td>{this.state.currentReport.active_hosts}</td>
                    </tr>
                  )}
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>
                        total hosts
                      </td>
                      <td>{this.state.currentReport.total_hosts}</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>target</td>
                    <td>{this.state.currentReport.target}</td>
                  </tr>
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>network</td>
                      <td>{this.state.currentReport.network}</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>ref</td>
                    <td>{this.state.currentReport.ref}</td>
                  </tr>
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>
                      scanner appliance
                    </td>
                    <td>{this.state.currentReport.scanner_appliance}</td>
                  </tr>
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>processed</td>
                      <td>{this.state.currentReport.processed}</td>
                    </tr>
                  )}
                  {currentTab === 'ep_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>
                        processing priority
                      </td>
                      <td>{this.state.currentReport.processing_priority}</td>
                    </tr>
                  )}
                  {currentTab === 'was_scans' && (
                    <tr>
                      <td style={{ textTransform: 'uppercase' }}>Summary</td>
                      <td>
                        {this.state.currentReport.summary
                          ? JSON.stringify(this.state.currentReport.summary)
                          : '<No Data>'}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>status</td>
                    <td>{this.state.currentReport.status}</td>
                  </tr>

                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>Launch date</td>
                    <td>
                      {this.state.currentReport.launch_datetime
                        ? moment(
                            this.state.currentReport.launch_datetime,
                          ).format('lll')
                        : ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>Last Updated</td>
                    <td>
                      {this.state.currentReport.updated_at
                        ? moment(this.state.currentReport.updated_at).format(
                            'lll',
                          )
                        : ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textTransform: 'uppercase' }}>Created at</td>
                    <td>
                      {this.state.currentReport.created_at
                        ? moment(this.state.currentReport.created_at).format(
                            'lll',
                          )
                        : ''}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </CustomModalWrapper>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              size="sm"
              onClick={() => this.toggle.bind(this)()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {this.renderLoader()}
      </>
    );
  }
}

export { ScanList };
